import I18n from 'i18n-js';
import React, { useContext } from 'react';

import { RCSelect } from '@reverbdotcom/commons/src/rc/forms/RCSelect';

import { SellFormContext } from '../../SellFormContext';
import ShippingSummary from '../../../ShippingSummary';
import { Field, ActionType } from '../../sellFormReducer';
import { SellFormSection } from '../SellFormSection';

function ShippingProfileCard() {
  const { formState, dispatch, sellFormViewData, loading, errorMap } = useContext(SellFormContext);

  const { shippingProfiles = [] } = sellFormViewData.me.shop;
  const selectedShippingProfile = shippingProfiles.find((sp) => sp.id === formState[Field.SHIPPING_PROFILE_ID]);
  const shippingProfileOptions = [
    { key: 0, value: '', label: I18n.t('discovery.sellForm.shippingSection.profileCard.selectNone') },
    ...shippingProfiles.map((sp) => ({ key: sp.id, value: sp.id, label: sp.name })),
  ];

  return (
    <SellFormSection.Card>
      <SellFormSection.FormSection title={I18n.t('discovery.sellForm.shippingSection.profileCard.header')}>
        <RCSelect
          id="shippingProfileId"
          name="shippingProfileId"
          label={I18n.t('discovery.sellForm.shippingSection.profileCard.select')}
          onChange={(evt) => {
            if (evt.target.value) {
              dispatch({ type: ActionType.SET_SHIPPING_PROFILE_ID, value: evt.target.value });
            } else {
              dispatch({ type: ActionType.SET_NO_SHIPPING });
            }
          }}
          value={formState[Field.SHIPPING_PROFILE_ID]}
          disabled={loading}
          errorText={errorMap[Field.SHIPPING_PROFILE_ID]}
        >
          {shippingProfileOptions.map(({ key, value, label }) => <RCSelect.Option key={key} value={value} label={label}/>)}
        </RCSelect>

        {selectedShippingProfile && (
          <ShippingSummary
            offersShipping={selectedShippingProfile.shippingRates.length > 0}
            offersLocalPickup={selectedShippingProfile.localPickup}
            shippingRates={selectedShippingProfile.shippingRates}
          />
        )}
      </SellFormSection.FormSection>
    </SellFormSection.Card>
  );
}

export default ShippingProfileCard;
